import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Travel = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator ">

                </div>
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>


            <div style={{
                marginTop: '2vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>
                <img style={{ width: '100%' }} className="vivify popIn" src="/assets/travel.png" alt="dad" />

                <h1 className="large-text"> <CountUp prefix="The Farthest You Traveled Was " end={1000} duration={6} />+ Miles</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad/trip');
                        }
                    } className="large-button">
                        Let's Continue
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Travel